<template>
  <div class="list-group list-group-escape-container mb-3">
    <slot name="before">
    </slot>
    <router-link v-if="shouldShowPersonalDataProcessingLink" :to="{ name: 'privacy'}" class="list-group-item list-group-item-action list-group-item-with-icon">
      <span>{{ $t('LoanTerms.personalDataProcessing') }}</span>
      <Icon icon-name="arrow-ios-forward-outline" icon-class="text-muted-more"></Icon>
    </router-link>
    <router-link :to="{ name: 'general-terms'}"
                 class="list-group-item list-group-item-action list-group-item-with-icon">
      <span>{{ $t('LoanTerms.termsAndConditions') }}</span>
      <Icon icon-name="arrow-ios-forward-outline" icon-class="text-muted-more"></Icon>
    </router-link>
  </div>
</template>

<script>
import Icon from '@shared/components/Icon'

export default {
  components: { Icon },
  props: ['showPersonalDataProcessingLink'],
  computed: {
    shouldShowPersonalDataProcessingLink() {
      return this.showPersonalDataProcessingLink === undefined ? true : this.showPersonalDataProcessingLink
    }
  }
}
</script>
